import React from "react";
import "../Marcas/Marcas.css";
import logo1 from "../../../assets/Marcas/delice.png";
import logo2 from "../../../assets/Marcas/delichizz.png";
import logo3 from "../../../assets/Marcas/untadeli.png";
import logo4 from "../../../assets/Marcas/frico.png";

const logos = [logo1, logo2, logo3,logo4];

const Marcas = () => {
  return (
    <div className="marcas-container">
      <div className="logou-row">
        {logos.map((logou, index) => (
          <div className="logou-container" key={index}>
            <img src={logou} alt={`Logou ${index + 1}`} className="logou-image" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marcas;
